import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import pick from 'lodash/pick';
import PropTypes from 'prop-types';
import React from 'react';
import omit from 'lodash/omit';
import { Redirect } from 'react-router-dom';
import { Button, Checkbox, Dimmer, Form, Header, Input, Loader, Modal, Radio } from 'semantic-ui-react';
import uuid from 'uuid/v1';
import {
  getUUID,
  isCCPaymentsAllowed,
  isECheckPaymentsAllowed,
  isHideNRTAForEnroll,
  isHideBillMeLaterForEnroll,
  isValidAllEmailAddress,
  isValidPhoneNumber,
  handleLocalSearchInputStorage,
  getWAPBusinessUnit,
  isPCICompliantForPayments,
} from '../../containers/Utils';
import { findKeyCode } from '../../containers/Utils/keyCodeMapping';
import CountrySelector from '../Countries';
import DateOfBirth from '../DateOfBirth';
import StateSelector from '../States';
import TermSelector from '../Terms';
import PaymentMethodSelector from '../PaymentMethods';
import { InternationalTerms, USTerms } from '../Terms/terms';
import emailTemplates from '../../containers/Utils/emailTemplates.json';
import './styles.css';

const replaceall = require('replaceall');

let paymentSessionId;

const fieldListMember = [
  'firstName',
  'middleName',
  'lastName',
  'dateOfBirth',
  'phoneNumber',
  'addressLine1',
  'addressLine2',
  'city',
  'state',
  'zipCode',
  'country',
  'emailAddress',
  'spanishMaterial',
];

const fieldListSpouse = [
  'spouseFirstName',
  'spouseMiddleName',
  'spouseLastName',
  'spouseEmailAddress',
];

const fieldDateOfBirth = [
  'birthMonth',
  'birthDay',
  'birthYear',
];

const tranformPersonToMember = (personFromSearch) => {
  let fieldsToPick = [
    ...fieldListMember,
    ...fieldDateOfBirth,
    ...fieldListSpouse,
    ...['personId', 'autoRenew', 'accountIndicator'],
  ];

  fieldsToPick = fieldsToPick.filter(each => each !== 'dateOfBirth');

  const member = pick(personFromSearch, fieldsToPick);

  if (isNil(member.autoRenew)) {
    member.autoRenew = 'N';
  }
  if (isNil(member.spanishMaterial)) {
    member.spanishMaterial = false;
  }
  if (isNil(member.accountIndicator)) {
    member.accountIndicator = 'A';
  }
  if (isNil(member.country) || member.country === '') {
    member.country = 'US';
  }
  fieldsToPick.forEach((field) => {
    if (member[field] === undefined) {
      member[field] = '';
    }
  });
  return member;
};

// eslint-disable-next-line
const { dateOfBirth, ...defaultMemberState } = [
  ...fieldListMember,
  ...fieldDateOfBirth,
  ...fieldListSpouse,
].reduce((obj, item) => {
  obj[item] = '';
  return obj;
}, { accountIndicator: 'A', autoRenew: 'N' });

defaultMemberState.spanishMaterial = false;
defaultMemberState.country = 'US';

class Enroll extends React.Component {
  static propTypes = {
    paymentResponse: PropTypes.object,
    paymentRequest: PropTypes.object,
    enrollPersonRequest: PropTypes.shape({
      personId: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      phoneNumber: PropTypes.string.isRequired,
      addressLine1: PropTypes.string.isRequired,
      city: PropTypes.string.isRequired,
      state: PropTypes.string.isRequired,
      zipCode: PropTypes.string.isRequired,
      country: PropTypes.string.isRequired,
    }),
    enrollMember: PropTypes.func.isRequired,
    enrollPerson: PropTypes.func.isRequired,
    searchMember: PropTypes.func.isRequired,
    setPaymentRequest: PropTypes.func.isRequired,
    createBillMe: PropTypes.func.isRequired,
    createBillMeExistingPerson: PropTypes.func.isRequired,
    removePaymentResponse: PropTypes.func.isRequired,
    removeEnrollPersonRequest: PropTypes.func.isRequired,
    setMemberRequest: PropTypes.func.isRequired,
    setSuccessMessage: PropTypes.func.isRequired,
    setErrorMessage: PropTypes.func.isRequired,
    validateAddress: PropTypes.func.isRequired,
    encryptData: PropTypes.func.isRequired,
    sendEmail: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!isEmpty(nextProps.paymentResponse) && !prevState.enrollActive) {
      return { enrollAllowSubmit: true, paymentActive: false };
    } else if (isEmpty(nextProps.paymentRequest) && prevState.paymentActive) {
      return { paymentActive: false };
    } else {
      return null;
    }
  }

  constructor(props) {
    super(props);
    paymentSessionId = getUUID();
    if (!isEmpty(props.enrollPersonRequest)) {
      const member = tranformPersonToMember(props.enrollPersonRequest);
      this.state = { member, enrollPerson: true };
    } else {
      this.state = { member: defaultMemberState };
    }
    this.state.member.paymentMethod = 'creditCard';
  }

  componentDidUpdate() {
    if (this.state.enrollAllowSubmit && !this.state.billMeLater) {
      this.submit(this.props.paymentResponse);
    }
  }

  componentWillUnmount() {
    // istanbul ignore else
    if (!isEmpty(this.props.paymentResponse)) {
      this.props.removePaymentResponse();
    }
    if (!isEmpty(this.props.enrollPersonRequest)) {
      this.props.removeEnrollPersonRequest();
    }
  }

  onChangeValue = (_, data) => {
    // create a copy to not mutate state.
    const member = { ...this.state.member };
    member[data.name] = data.value;
    this.setState({
      member,
    });
  }

  onKeyPressExecute = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  onChangeTermsValue = (_, data) => {
    const member = { ...this.state.member };
    member[data.name] = data.value;
    this.setState({
      member,
    });
    this.setState({ showPaymentMethodSelector: true });
    if (data.value === 'US12') {
      member.paymentMethod = 'creditCard';
      this.state.member.paymentMethod = 'creditCard';
      this.setState({ billMeDisabled: true, billMeLater: false });
    } else {
      this.setState({ billMeDisabled: false });
    }
  }

  onChangePaymentMethodValue = (_, data) => {
    const member = { ...this.state.member };
    member[data.name] = data.value;
    this.setState({
      member,
    });
  }

  onChangeCountryValue = (_, data) => {
    // create a copy to not mutate state.
    const member = { ...this.state.member };
    if (member.country !== data.value) {
      member.membershipTerm = '';
    }
    member.country = data.value;
    this.setState({
      member,
    });
  }

  onChangeBillMe = (_, data) => {
    const member = { ...this.state.member };
    member.autoRenew = 'N';
    this.setState({
      billMeLater: data.checked,
      member,
    });
    this.setState({ showPaymentMethodSelector: !data.checked });
  }

  onChangeSpanishMaterial = (_, data) => {
    const { member } = this.state;
    member.spanishMaterial = data.checked;
    this.setState({
      member,
    });
  }

  getTerm = (term) => {
    let membershipTerm = USTerms.filter(usTerm => usTerm.id === term);
    if (membershipTerm.length === 0) {
      membershipTerm = InternationalTerms.filter(intlTerm => intlTerm.id === term);
    }

    if (membershipTerm.length === 1) {
      return membershipTerm[0];
    }
    return {};
  }

  closeMemberFound = () => {
    this.setState({ memberFound: undefined });
  };

  isValidateInputs = () => {
    const { setErrorMessage } = this.props;
    const { member } = this.state;
    let errorMessage = '';
    if (member.paymentMethod === 'memberEnteredCreditCard') {
      if (member.emailAddress.trim() === '') {
        errorMessage += 'Email Address is required. ';
      }
    }
    errorMessage += isValidPhoneNumber(member.phoneNumber);
    errorMessage += isValidAllEmailAddress(member.emailAddress, member.spouseEmailAddress);
    if (errorMessage !== '') {
      setErrorMessage(errorMessage.substring(0, errorMessage.length - 2));
      return false;
    }
    return true;
  }

  handleSubmitClicked = () => {
    const { member } = this.state;
    if (member.paymentMethod === 'memberEnteredCreditCard') {
      this.handleMemberEnteredCreditCard();
      return;
    }

    if (this.isValidateInputs()) {
      // skip search if we are enrolling existing person
      if (this.state.enrollPerson) {
        this.handleEnroll();
      } else {
        this.setState({ searchActive: true });
        this.searchMember();
      }
    }
  };

  handleMemberEnteredCreditCardRedirectToSearch = () => {
    this.setState({ redirectToSearch: true });
  };

  handleMemberEnteredCreditCard = () => {
    const { member } = this.state;
    const { searchMember, setErrorMessage, validateAddress, encryptData, sendEmail } = this.props;
    if (this.isValidateInputs()) {
      this.setState({ searchActive: true });
      searchMember({
        birthMonth: member.birthMonth,
        birthDay: member.birthDay,
        birthYear: member.birthYear,
        firstName: member.firstName,
        lastName: member.lastName,
        zipCode: member.zipCode,
        country: member.country,
      })
        .then((searchMemberResponse) => {
          if (searchMemberResponse.data.members.matchCount === 1) {
            this.existingMember = { ...searchMemberResponse.data.members.member };
            this.setState({ searchActive: false, memberFound: true });
          } else if (searchMemberResponse.data.members.matchCount > 1) {
            this.setState({ searchActive: false });
            setErrorMessage('Multiple members found. Please, verify your entries');
          } else {
            this.setState({ searchActive: false });
            // Validate Address
            const address = {
              addressLine1: member.addressLine1,
              addressLine2: member.addressLine2,
              city: member.city,
              state: member.state,
              zipCode: member.zipCode,
              country: member.country,
            };
            this.setState({ validateAddressActive: true });
            const p = (member.country === 'US' || member.country === '') ? validateAddress(address) : Promise.resolve({});
            p.then((addressResponse) => {
              this.setState({ validateAddressActive: false });
              const term = this.getTerm(member.membershipTerm);
              member.membershipTerm = term.length * 12;
              member.autoRenew = term.autoRenew ? 'Y' : 'N';
              member.paymentMethod = 'CC';
              member.vendorId = process.env.DSM_VENDORID;
              member.merchantId = process.env.MERCHANT_ID;
              const busUnit = getWAPBusinessUnit(this.props).toUpperCase();
              const commLang = (member.spanishMaterial ? '2' : '1');
              member.campaignId = findKeyCode(busUnit, commLang, '1', 'A');
              // encrypt member data
              this.setState({ encryptDataActive: true });
              encryptData({ data: JSON.stringify(member), saltName: 'wapdsm' })
                .then((encryptDataResponse) => {
                  this.setState({ encryptDataActive: false });
                  const encryptedMember = encryptDataResponse.data.encryptData.encryptedData;
                  const joinEmailTemplate = emailTemplates.UserEnteredCreditCard.join;
                  let htmlBodyVal = replaceall('{DSMMainURL}', process.env.DSM_MAIN_URL, joinEmailTemplate.Body);
                  htmlBodyVal = replaceall('{encryptedMemberData}', encryptedMember, htmlBodyVal);
                  htmlBodyVal = replaceall('{campaignIdValue}', member.campaignId, htmlBodyVal);
                  // send email to member
                  this.setState({ sendEmailActive: true });
                  sendEmail({
                    fromEmailAddress: joinEmailTemplate.FromEmail,
                    toEmailAddress: member.emailAddress,
                    subject: joinEmailTemplate.Subject,
                    htmlBody: htmlBodyVal,
                  })
                    .then((sendEmailResponse) => {
                      this.setState({ sendEmailActive: false });
                      // save data in memberSearchInput cookie
                      const searchCookie = {
                        id: '',
                        birthMonth: member.birthMonth,
                        birthDay: member.birthDay,
                        birthYear: member.birthYear,
                        firstName: member.firstName,
                        lastName: member.lastName,
                        addressLine1: member.addressLine1,
                        zipCode: member.zipCode,
                        country: member.country,
                        phoneNumber: member.phoneNumber,
                      };
                      handleLocalSearchInputStorage('add', searchCookie, '');
                      // popup done message to agent
                      this.setState({ memberEnteredCreditCardDone: true });
                    }).catch((err) => {
                      this.setState({ sendEmailActive: false });
                      setErrorMessage(err);
                    });
                }).catch((err) => {
                  this.setState({ encryptDataActive: false });
                  setErrorMessage(err);
                });
            }).catch((err) => {
              this.setState({ validateAddressActive: false });
              setErrorMessage(err);
            });
          }
        })
        .catch((err) => {
          this.setState({ searchActive: false });
          setErrorMessage('Failed to lookup member. Please, try again');
        });
    }
  }

  handleEnroll = () => {
    const { member, errorEnroll, billMeLater } = this.state;
    const { validateAddress, setErrorMessage } = this.props;

    if (errorEnroll) {
      this.submit(this.props.paymentResponse);
    } else if (billMeLater) {
      this.billMe();
    } else {
      const address = {
        addressLine1: member.addressLine1,
        addressLine2: member.addressLine2,
        city: member.city,
        state: member.state,
        zipCode: member.zipCode,
        country: member.country,
      };
      this.setState({ validateAddressActive: true });

      const p = (member.country === 'US' || member.country === '') ? validateAddress(address) : Promise.resolve({});
      p.then((response) => {
        this.merchantReferenceCode = uuid();
        this.props.setPaymentRequest({
          member: {
            ...member,
            phoneNumber: !member.phoneNumber || member.phoneNumber === '' ? '1231231234' : member.phoneNumber,
          },
          merchantReferenceCode: this.merchantReferenceCode,
          amount: this.getTerm(member.membershipTerm).value,
        });
        this.setState({ validateAddressActive: false, paymentActive: true });
      })
        .catch((err) => {
          this.setState({ validateAddressActive: false });
          setErrorMessage(err);
        });
    }
  };

  isValidForEnroll = () => {
    const { member } = this.state;
    return !isEmpty(member.lastName) &&
      !isEmpty(member.firstName) &&
      !isEmpty(member.membershipTerm) &&
      !isEmpty(member.addressLine1) &&
      !isEmpty(member.city) &&
      !isEmpty(member.state) &&
      !isEmpty(member.zipCode) &&
      !isEmpty(member.country) &&
      !isEmpty(member.paymentMethod);
  };

  handleCancel = () => {
    if (!isEmpty(this.props.paymentResponse)) {
      this.props.removePaymentResponse();
    }
    this.setState({ cancel: true });
  };

  handleMemberFoundProceed = () => {
    if (this.existingMember.id) {
      this.handleMemberRenew();
    } else {
      // this is the case for existing person but not member.
      const member = tranformPersonToMember(this.existingMember);
      this.setState({ member, memberFound: undefined, enrollPerson: true });
    }
  };

  handleMemberRenew = () => {
    this.setState({ memberFound: undefined, redirectToRenew: true });
  };

  searchMember = () => {
    const { member } = this.state;
    const { searchMember, setErrorMessage } = this.props;
    searchMember({
      birthMonth: member.birthMonth,
      birthDay: member.birthDay,
      birthYear: member.birthYear,
      firstName: member.firstName,
      lastName: member.lastName,
      zipCode: member.zipCode,
      country: member.country,
    })
      .then((response) => {
        if (response.data.members.matchCount === 1) {
          this.existingMember = { ...response.data.members.member };
          this.setState({ searchActive: false, memberFound: true });
        } else if (response.data.members.matchCount > 1) {
          this.setState({ searchActive: false });
          setErrorMessage('Multiple members found. Please, verify your entries');
        } else {
          this.setState({ searchActive: false });
          this.handleEnroll();
        }
      })
      .catch((err) => {
        this.setState({ searchActive: false });
        setErrorMessage('Failed to lookup member. Please, try again');
      });
  };

  mapPayment = (member, paymentResponse) => {
    if (paymentResponse) {
      const response = { ...paymentResponse.response };

      const today = new Date();
      let month = (1 + today.getMonth()).toString();
      month = month.length > 1 ? month : `0${month}`;

      let day = today.getDate().toString();
      day = day.length > 1 ? day : `0${day}`;

      const todayDate = `${month}/${day}/${today.getFullYear()}`;

      let ccAuth = {};
      let eCheckAuth = {};
      member.paymentMethod = (member.paymentMethod === undefined ? 'creditCard' : member.paymentMethod);
      if (member.paymentMethod === 'creditCard') {
        ccAuth = {
          firstName: response.req_bill_to_forename,
          lastName: response.req_bill_to_surname,
          addrLine1: response.req_bill_to_address_line1,
          addrLine2: response.req_bill_to_address_line2 || '',
          city: response.req_bill_to_address_city,
          state: response.req_bill_to_address_state,
          zip: response.req_bill_to_address_postal_code,
          countryCode: response.req_bill_to_address_country,
          phone: response.req_bill_to_phone,
          cardExpireDt: response.req_card_expiry_date ? response.req_card_expiry_date.replace('-', '') : '',
          cardType: response.req_card_type,
          cclast4Digits: response.req_card_number ? response.req_card_number.slice(-4) : '',
          subscriptionId: response.payment_token,
          currencyCd: 'USD',
          amount: response.req_amount,
          requestId: response.transaction_id,
          merchantId: process.env.MERCHANT_ID,
          merchantReferenceCd: response.merchant_reference_code,
          cvv2: 'NOT_REQUIRED',
        };
      } else if (member.paymentMethod === 'eCheck') {
        eCheckAuth = {
          firstName: response.req_bill_to_forename,
          lastName: response.req_bill_to_surname,
          addrLine1: response.req_bill_to_address_line1,
          addrLine2: response.req_bill_to_address_line2 || '',
          city: response.req_bill_to_address_city,
          state: response.req_bill_to_address_state,
          zip: response.req_bill_to_address_postal_code,
          countryCode: response.req_bill_to_address_country,
          merchantId: process.env.MERCHANT_ID,
          subscriptionId: response.subscriptionId,
          currencyCd: 'USD',
          amount: response.req_amount,
          echeckAuthInd: 'Y',
          acctLast4Digits: response.req_echeck_account_number,
        };
      }

      const payment = {
        accountStatus: '0',
        assocInd: member.accountIndicator,
        ccAuthorization: ccAuth,
        wsecDebit: eCheckAuth,
        decisionManager: {
          merchantFld1: 'web',
          merchantFld5: 'individual',
          deviceFingerprint: paymentSessionId,
          ipAddress: window.localStorage.getItem('publicIP'),
        },
        depositDate: todayDate,
        paymentAmount: member.membershipTerm,
        primaryPersonId: member.personId,
      };

      if (member.paymentMethod === 'creditCard') {
        payment.paymentMethod = 'R';
      } else if (member.paymentMethod === 'eCheck') {
        payment.paymentMethod = 'A';
      }
      return payment;
    }
    return null;
  }

  submit = (paymentResponse) => {
    const {
      enrollMember,
      enrollPerson,
      setErrorMessage,
      setSuccessMessage,
      removePaymentResponse,
      removeEnrollPersonRequest,
    } = this.props;

    const member = { ...this.state.member };

    const term = this.getTerm(member.membershipTerm);
    member.membershipTerm = term.value;
    member.autoRenew = term.autoRenew ? 'Y' : 'N';

    if (paymentResponse.response.error) {
      this.setState({ enrollActive: false, enrollAllowSubmit: false });
      setErrorMessage(paymentResponse.response.message);
      this.props.removePaymentResponse();
      return null;
    }
    this.setState({
      enrollAllowSubmit: false,
      enrollActive: true,
    });

    if (this.state.enrollPerson) {
      return enrollPerson({
        variables: {
          enrollPersonInput: {
            personId: member.personId,
            membershipTerm: member.membershipTerm,
            autoRenew: member.autoRenew,
            accountIndicator: member.accountIndicator,
            spanishMaterial: member.spanishMaterial,
            payment: this.mapPayment(member, paymentResponse),
          },
        },
      })
        .then((response) => {
          const enrolledMember = response.data.enrollExistingPerson;
          this.setState({
            member: enrolledMember,
            errorEnroll: false,
            enrollActive: false,
            enrollSuccess: true,
          });
          setSuccessMessage(`Enrolled member: ${member.lastName} - ${enrolledMember.id}`);
          removePaymentResponse();
          removeEnrollPersonRequest();
        })
        .catch((err) => {
          this.setState({ enrollActive: false, errorEnroll: true });
          setErrorMessage(`Failed to enroll due to error: ${err.message.replace('GraphQL error: ', '')}`);
        });
    }
    member.payment = this.mapPayment(member, paymentResponse);
    return enrollMember({
      variables: {
        member: omit(member, ['paymentMethod']),
      },
    })
      .then((response) => {
        const enrolledMember = response.data.enrollMember;
        this.setState({
          member: enrolledMember,
          errorEnroll: false,
          enrollActive: false,
          enrollSuccess: true,
        });
        removePaymentResponse();
        setSuccessMessage(`Enrolled member: ${member.lastName} - ${enrolledMember.id}`);
      })
      .catch((err) => {
        this.setState({ enrollActive: false, errorEnroll: true });
        setErrorMessage(`Failed to enroll due to error: ${err.message.replace('GraphQL error: ', '')}`);
      });
  };

  billMe = () => {
    const { createBillMe, createBillMeExistingPerson, setErrorMessage, setSuccessMessage, validateAddress } = this.props;
    const member = { ...this.state.member };

    member.membershipTerm = this.getTerm(member.membershipTerm).value;

    const address = {
      addressLine1: member.addressLine1,
      addressLine2: member.addressLine2,
      city: member.city,
      state: member.state,
      zipCode: member.zipCode,
      country: member.country,
    };
    this.setState({ validateAddressActive: true });

    const addrPromise = (member.country === 'US' || member.country === '') ? validateAddress(address) : Promise.resolve({});
    addrPromise
      .then((addrResponse) => {
        const p = (member.personId) ?
          createBillMeExistingPerson({
            variables: {
              input: {
                accountIndicator: member.accountIndicator,
                membershipTerm: member.membershipTerm,
                personId: member.personId,
                spouseId: member.spouseId,
              },
            },
          })
          :
          createBillMe({
            variables: {
              member: omit(member, ['paymentMethod']),
            },
          });

        this.setState({
          validateAddressActive: false,
          enrollActive: true,
        });
        p.then((response) => {
          this.setState({
            enrollActive: false,
            billMeSuccess: true,
            billMeLater: false,
          });

          const data = (member.personId) ? response.data.createBillMeExistingPerson : response.data.createBillMe;
          member.personId = data.personId;
          member.spouseId = data.spouseId;
          member.addressLine1 = data.addressLine1;
          member.addressLine2 = data.addressLine2;
          member.city = data.city;
          member.state = data.state;
          member.zipCode = data.zipCode;

          this.existingMember = member;
          setSuccessMessage(`Created member: ${member.firstName} ${member.lastName} with Bill Me Option`);
          this.handleMemberFoundProceed();
        })
          .catch((err) => {
            this.setState({ enrollActive: false });
            setErrorMessage(`Failed to enroll due to error: ${err.message.replace('GraphQL error: ', '')}`);
          });
      })
      .catch((err) => {
        this.setState({ validateAddressActive: false });
        setErrorMessage(err);
      });
  };

  render() {
    const {
      member,
      enrollActive,
      cancel,
      errorEnroll,
      searchActive,
      memberFound,
      redirectToRenew,
      redirectToSearch,
      billMeLater,
      enrollSuccess,
      enrollPerson,
      enrollAllowSubmit,
      paymentActive,
      validateAddressActive,
      encryptDataActive,
      sendEmailActive,
      billMeSuccess,
      billMeDisabled,
      showPaymentMethodSelector = true,
      memberEnteredCreditCardDone,
    } = this.state;

    const { setMemberRequest } = this.props;

    if (cancel) {
      return <Redirect to="/search" />;
    }

    if (enrollSuccess) {
      setMemberRequest({ ...member });
      return <Redirect to="/view" />;
    }

    if (redirectToRenew) {
      setMemberRequest({ ...this.existingMember });
      return <Redirect to="/renew" />;
    }

    if (redirectToSearch) {
      return <Redirect to="/search" />;
    }

    const submitEnabled = this.isValidForEnroll();
    let loadingMessage = searchActive && 'Searching Members...';
    loadingMessage = loadingMessage || (enrollActive && 'Enrolling Member...');
    loadingMessage = loadingMessage || (paymentActive && 'Invoking Payment...');
    loadingMessage = loadingMessage || (validateAddressActive && 'Validating Address...');
    loadingMessage = loadingMessage || (encryptDataActive && 'Encrypting Member Data...');
    loadingMessage = loadingMessage || (sendEmailActive && 'Sending Email to Member...');
    const readonly = enrollPerson === true;
    const modalMessage = this.existingMember && this.existingMember.id ?
      'Would you like to renew this member?' :
      'Would you like to enter payment?';
    const headerMessage = readonly ?
      'Please select membership fee for existing person. Member data can not be modified.' :
      'Please enter the following as you would like it to appear on your membership card.';
    return (
      <React.Fragment>
        {memberEnteredCreditCardDone &&
          <Modal
            open={memberEnteredCreditCardDone === true}
            styleName="popUp"
          >
            <Modal.Header>Email sent to Member</Modal.Header>
            <Modal.Content>
              <p>Email sent to <b>{member.emailAddress}</b> to complete the Credit Card details.
              You will be redirected to search page with this member details pre-populated.
              </p>
            </Modal.Content>
            <Modal.Actions>
              <Button
                id="memberEnteredCreditCardDoneOK"
                positive
                content="Ok"
                onClick={this.handleMemberEnteredCreditCardRedirectToSearch}
              />
            </Modal.Actions>
          </Modal>
        }
        <Modal
          open={memberFound === true}
          onClose={this.closeMemberFound}
          styleName="popUp"
        >
          <Modal.Header>Member Found</Modal.Header>
          <Modal.Content>
            <p>{modalMessage}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              id="memberFoundEnrollNoButton"
              negative
              content="No"
              onClick={this.closeMemberFound}
            />
            <Button
              id="memberFoundEnrollYesButton"
              positive
              content="Yes"
              onClick={this.handleMemberFoundProceed}
            />
          </Modal.Actions>
        </Modal>

        <Dimmer.Dimmable
          as="div"
          dimmed={searchActive || enrollActive || paymentActive || enrollAllowSubmit || validateAddressActive
          || encryptDataActive || sendEmailActive}
        >
          <Dimmer active={searchActive || enrollActive || paymentActive || enrollAllowSubmit || validateAddressActive
            || encryptDataActive || sendEmailActive}
          >
            <Loader inverted>{loadingMessage}</Loader>
          </Dimmer>
          <div styleName="enroll-container">
            <Form>
              <div styleName="member-info">
                <Header as="h3" dividing>
                  <Header.Content>
                    Member Information
                    <Header.Subheader>
                      {headerMessage}
                    </Header.Subheader>
                    {
                      billMeSuccess &&
                      <Header.Subheader>
                        Person has been Billed.
                      </Header.Subheader>
                    }
                  </Header.Content>
                </Header>
                <div>
                  <Form.Field>
                    <span styleName="assn-type-label">Membership Type</span>
                  </Form.Field>
                  <Form.Group inline>
                    <Form.Field
                      id="accountIndicatorA"
                      control={Radio}
                      label="AARP"
                      value="A"
                      onChange={this.onChangeValue}
                      name="accountIndicator"
                      key="accountIndicatorA"
                      checked={member.accountIndicator === 'A'}
                      readOnly={readonly}
                    />
                    <div>
                      {
                        (!isHideNRTAForEnroll(this.props)) ?
                          <Form.Field
                            id="accountIndicatorN"
                            control={Radio}
                            label="NRTA"
                            value="N"
                            onChange={this.onChangeValue}
                            name="accountIndicator"
                            key="accountIndicatorN"
                            checked={member.accountIndicator === 'N'}
                            readOnly={readonly}
                          />
                          : null
                      }
                    </div>
                  </Form.Group>
                </div>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="First Name"
                    value={member.firstName}
                    onChange={this.onChangeValue}
                    name="firstName"
                    readOnly={readonly}
                    required
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Middle Name"
                    value={member.middleName}
                    onChange={this.onChangeValue}
                    name="middleName"
                    readOnly={readonly}
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Last Name"
                    value={member.lastName}
                    onChange={this.onChangeValue}
                    name="lastName"
                    readOnly={readonly}
                    required
                    fluid
                    autoComplete="disabled"
                  />
                </Form.Group>
                <DateOfBirth
                  member={member}
                  fieldChangeHandler={this.onChangeValue}
                  readOnly={readonly}
                  memberLevel="primary"
                />
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="Mailing Address"
                    value={member.addressLine1}
                    onChange={this.onChangeValue}
                    name="addressLine1"
                    readOnly={readonly}
                    required
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Address (line 2)"
                    value={member.addressLine2}
                    onChange={this.onChangeValue}
                    name="addressLine2"
                    readOnly={readonly}
                    fluid
                    autoComplete="disabled"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Field
                    control={Input}
                    label="City"
                    value={member.city}
                    onChange={this.onChangeValue}
                    name="city"
                    readOnly={readonly}
                    width="8"
                    required
                    autoComplete="disabled"
                  />
                  <StateSelector
                    member={member}
                    fieldChangeHandler={this.onChangeValue}
                    width="5"
                    readOnly={readonly}
                    required
                  />
                  <Form.Field
                    control={Input}
                    label="Zip/Postal Code"
                    value={member.zipCode}
                    onChange={this.onChangeValue}
                    name="zipCode"
                    readOnly={readonly}
                    width="3"
                    required
                    autoComplete="disabled"
                  />
                </Form.Group>
                <CountrySelector
                  member={member}
                  fieldChangeHandler={this.onChangeCountryValue}
                  readOnly={readonly}
                  width="4"
                  required
                />
                <Form.Field
                  control={Input}
                  label="Phone"
                  value={member.phoneNumber}
                  onChange={this.onChangeValue}
                  name="phoneNumber"
                  readOnly={readonly}
                  placeholder={readonly ? '' : '5555555555'}
                  width="4"
                  autoComplete="disabled"
                  maxLength="10"
                  onKeyPress={this.onKeyPressExecute}
                />
                <Form.Field
                  control={Input}
                  label="Email Address"
                  value={member.emailAddress}
                  onChange={this.onChangeValue}
                  name="emailAddress"
                  readOnly={readonly}
                  width="12"
                  autoComplete="disabled"
                />
                <Form.Field
                  control={Checkbox}
                  label="Please send membership materials to me in Spanish when available."
                  onChange={this.onChangeSpanishMaterial}
                  name="spanishMaterial"
                  readOnly={readonly}
                  checked={member.spanishMaterial}
                />
              </div>
              <div styleName="member-info spouse-info">
                <Header as="h3" dividing>
                  <Header.Content>
                    Spouse/Partner Information
                    <Header.Subheader>
                      Membership fee includes spouse/partner <b>free</b>.
                    </Header.Subheader>
                    <Header.Subheader>
                      Your spouse will also receive a membership card.
                    </Header.Subheader>
                  </Header.Content>
                </Header>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    label="First Name"
                    value={member.spouseFirstName}
                    onChange={this.onChangeValue}
                    name="spouseFirstName"
                    readOnly={readonly}
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Middle Name"
                    value={member.spouseMiddleName}
                    onChange={this.onChangeValue}
                    name="spouseMiddleName"
                    readOnly={readonly}
                    fluid
                    autoComplete="disabled"
                  />
                  <Form.Field
                    control={Input}
                    label="Last Name"
                    value={member.spouseLastName}
                    onChange={this.onChangeValue}
                    name="spouseLastName"
                    readOnly={readonly}
                    fluid
                    autoComplete="disabled"
                  />
                </Form.Group>
                <Form.Field
                  control={Input}
                  label="Email Address"
                  value={member.spouseEmailAddress}
                  onChange={this.onChangeValue}
                  name="spouseEmailAddress"
                  readOnly={readonly}
                  width="12"
                  autoComplete="disabled"
                />
              </div>
              <TermSelector
                member={member}
                fieldChangeHandler={this.onChangeTermsValue}
                allowCCPayments={isCCPaymentsAllowed(this.props)}
                allowECheckPayments={isECheckPaymentsAllowed(this.props)}
                subHeader="Please enroll me as a member of AARP."
              />
              <div>
                {
                  (!isHideBillMeLaterForEnroll(this.props)) ?
                    <Form.Field
                      id="billMeField"
                      styleName="bill-me-field"
                      control={Checkbox}
                      label="Bill Me Later"
                      onChange={this.onChangeBillMe}
                      name="billMeLater"
                      key="billMeLater"
                      disabled={errorEnroll || billMeDisabled}
                      checked={billMeLater === true}
                    />
                    : null
                }
              </div>
              <div>
                {
                  (isECheckPaymentsAllowed(this.props) && showPaymentMethodSelector) ?
                    <PaymentMethodSelector
                      member={member}
                      fieldChangeHandler={this.onChangePaymentMethodValue}
                      allowCCPayments={isCCPaymentsAllowed(this.props)}
                      allowECheckPayments={isECheckPaymentsAllowed(this.props)}
                      pciCompliantForPayments={isPCICompliantForPayments(this.props)}
                    />
                    : null
                }
              </div>
              <Button
                id="payWithPopupButton"
                styleName="enroll-button"
                disabled={!submitEnabled}
                type="button"
                content="Submit"
                onClick={this.handleSubmitClicked}
              />
              <Button
                id="cancelEnrollButton"
                type="button"
                styleName="cancel-button"
                content="Cancel"
                onClick={this.handleCancel}
              />
              <img
                // eslint-disable-next-line
                src={`https://h.online-metrix.net/fp/clear.png?org_id=${process.env.CYBERSOURCE_ORGID}&session_id=${process.env.MERCHANT_ID}${paymentSessionId}&m=2`}
                alt=""
              />
            </Form>
          </div>
        </Dimmer.Dimmable>
      </React.Fragment>
    );
  }
}

export default Enroll;



// WEBPACK FOOTER //
// ./src/app/components/Enroll/index.js